"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollArea = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const state_1 = require("./state");
const context_2 = require("./context");
const useSyncStore_1 = require("../../hooks/useSyncStore");
const scrollShadows_1 = require("../scrollShadows");
const rootClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    d: 'flex',
    flexDirection: 'column',
    ov: 'hidden',
    z: 10,
});
const shadowTopClass = (0, nano_theme_1.drule)({
    pointerEvents: 'none',
    trs: 'opacity .3s',
    pos: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    z: 2,
    h: '5px',
});
const shadowBottomClass = (0, nano_theme_1.drule)({
    pointerEvents: 'none',
    trs: 'opacity .3s',
    pos: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    z: 2,
    h: '5px',
});
const ScrollAreaShadows = ({ state, flat }) => {
    const styles = (0, context_1.useStyles)();
    const shade = styles.light ? 0 : 1;
    const shadowGradient = (toDeg) => `linear-gradient(${toDeg}deg, ${styles.g(shade, 0.05)}, ${styles.g(shade, 0.03)} 50%, ${styles.g(shade, 0)})`;
    const shadowTopCls = shadowTopClass({ bg: shadowGradient(180) });
    const shadowBottomCls = shadowBottomClass({ bg: shadowGradient(0) });
    const scrollTop = (0, useSyncStore_1.useSyncStore)(state.scrollTop$);
    const maxScrollTop = (0, useSyncStore_1.useSyncStore)(state.maxScrollTop$);
    const headerHeight = (0, useSyncStore_1.useSyncStore)(state.headerHeight$);
    const footerHeight = (0, useSyncStore_1.useSyncStore)(state.footerHeight$);
    const background = flat ? styles.g(0, 0.1) : void 0;
    const [showTopShadow, showBottomShadow] = (0, scrollShadows_1.getScrollShadowVisibility)(scrollTop, maxScrollTop);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: shadowTopCls, style: {
                top: headerHeight,
                opacity: showTopShadow ? 1 : 0,
                background,
                height: flat ? 3 : void 0,
            } }),
        React.createElement("div", { className: shadowBottomCls, style: {
                bottom: footerHeight,
                opacity: showBottomShadow ? 1 : 0,
                background,
                height: flat ? 3 : void 0,
            } })));
};
const ScrollArea = ({ state: _state, alwaysVisible, railWidth, hideDelay, minThumbSize, shadow, shadowFlat, children, className, ...rest }) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: props are synced via useLayoutEffect below; only _state should trigger re-creation
    const state = React.useMemo(() => {
        if (_state)
            return _state;
        return new state_1.ScrollState({ alwaysVisible, railWidth, hideDelay, minThumbSize });
    }, [_state]);
    React.useLayoutEffect(() => {
        if (!_state) {
            if (alwaysVisible !== undefined)
                state.alwaysVisible$.next(alwaysVisible);
            if (railWidth !== undefined)
                state.railWidth$.next(railWidth);
        }
    }, [alwaysVisible, railWidth, _state, state]);
    React.useLayoutEffect(() => state.start(), [state]);
    return (React.createElement(context_2.ctx.Provider, { value: state },
        React.createElement("div", { ...rest, className: rootClass + (className ? ' ' + className : '') },
            children,
            shadow || shadowFlat ? React.createElement(ScrollAreaShadows, { state: state, flat: shadowFlat }) : null)));
};
exports.ScrollArea = ScrollArea;
